import gql from "graphql-tag";

export const GET_Cashfloat = gql`
  query GET_Cashfloat($condition: String!) {
    cashfloat: CashFloatList(where: $condition) {
      id: Id
      uid: Uid
      closeDate: CloseDate
      GroupRead {
        groupUuid: Uuid
      }
    }
  }
`;
